/**
 * Single source of truth for retail shipping policy copy and thresholds.
 *
 * Free shipping applies to US domestic orders only. International orders are
 * always rated at checkout by the carrier and never qualify for the promo.
 */

export const FREE_SHIPPING_THRESHOLD = 50;

export const FREE_SHIPPING_REGION = 'US domestic';

/** Short badge label, e.g. product pages and trust badges. */
export const FREE_SHIPPING_BADGE = `Free US Shipping $${FREE_SHIPPING_THRESHOLD}+`;

/** Full sentence used in cart / checkout summaries. */
export const FREE_SHIPPING_LINE = `Free shipping on US domestic orders over $${FREE_SHIPPING_THRESHOLD}`;

/** Disclaimer shown wherever the free shipping offer is mentioned. */
export const INTERNATIONAL_SHIPPING_NOTE =
  'International orders do not qualify — rates are calculated at checkout.';

/** Announcement bar text. */
export const FREE_SHIPPING_ANNOUNCEMENT = `FREE US SHIPPING - Orders Over $${FREE_SHIPPING_THRESHOLD}`;

/** Remaining spend message for progress meters. */
export const freeShippingRemainingLabel = (subtotal: number) =>
  `Add $${Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2)} more for free US shipping`;
